export function uploadRequestTypePatcher(data) {
    return {
        __typename: 'UploadRequest',
        ...data,
        uploadRequest: {
            __typename: 'UploadRequest',
            ...data.uploadRequest,
        },
    };
}
